import Configs from "../config";
import { IExternalUser } from "../types/ExternalUserTypes";

interface ICreateExternalUser {
  name: string;
  mainUserUid: string;
}

export async function GetExternalUsers(mainUserUid: string) {
  const response = await fetch(
    `${Configs.SERVER_URL}/externalUser/userUid/${mainUserUid}`
  );

  const externalUsers = await response.json();

  return externalUsers.data as IExternalUser[];
}

export async function CreateExternalUser(data: ICreateExternalUser) {
  const response = await fetch(`${Configs.SERVER_URL}/externalUser`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify(data),
  });

  const responseData = await response.json();

  return responseData;
}

export async function DeleteExternalUser(mainUserUid: string) {
  const response = await fetch(
    `${Configs.SERVER_URL}/externalUser/${mainUserUid}`,
    {
      method: "delete",
    }
  );

  const responseData = await response.json();

  return responseData;
}
